import React from 'react';
import clsx from 'clsx';

/**
 * Full-screen layer behind popups: the dimmed backdrop, or the fixed container
 * that centres a dialog. Position and layout come from `className`; `tone` sets
 * how dark the backdrop is. For a complete dialog, use `Modal`.
 */

export const OVERLAY_TONES = {
  'dim-30': 'bg-black/30',
  'dim-40': 'bg-black/40',
  'dim-45': 'bg-black/45',
  'dim-50': 'bg-black/50',
  'dim-70': 'bg-black/70',
  /** No backdrop colour (a positioning layer). */
  custom: '',
} as const;

export type OverlayTone = keyof typeof OVERLAY_TONES;

export type OverlayProps = React.HTMLAttributes<HTMLDivElement> & { tone?: OverlayTone };

export const Overlay = React.forwardRef<HTMLDivElement, OverlayProps>(({ tone = 'custom', className, ...props }, ref) => (
  <div ref={ref} className={clsx(OVERLAY_TONES[tone], className) || undefined} {...props} />
));

Overlay.displayName = 'Overlay';
